<template>
  <grid :id="id"
        :title="title"
        :columns="columns"
        :paginated-dto="rows"
        :pagination="false"
        :download-btn="false"
        :refresh-btn="false"
        compact
        class="gateway-last-events mb-3"
  >
    <template slot="date" slot-scope="props">{{ props.dto.date | date }}</template>

    <div slot="actions" slot-scope="props" class="actions">
      <i :title="$t('g-lastEvents:markAsRead') | capitalize" class="icon-check" @click="markAsRead(props.dto)" />
    </div>
  </grid>
</template>

<script>
import { isNaN } from 'lodash-es'
import to from '@/modules/await-to-js'
import constants from '@/configuration/constants'

export default {
  props: {
    id: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    events: {
      type: Array,
      required: true
    }
  },

  computed: {
    columns () {
      return [
        { text: this.$t('g-lastEvents:date'), slot: 'date' },
        { text: this.$t('g-lastEvents:name'),
          formatter: event => {
            let name = event.name
            if (event.category1) name += ' (' + event.category1 + 'MHz)'
            return name
          }
        },
        { text: this.$t('g-lastEvents:value'), formatter: this.formatValue },
        { slot: 'actions' }
      ]
    },

    // Simulate a paginatedDto for grid
    rows () {
      return {
        count: this.events.length,
        list: this.events,
        nbPages: 1,
        page: 1,
        pageSize: constants.overviewNbEvents,
        totalCount: this.events.length
      }
    }
  },

  methods: {
    formatValue (event) {
      // Format numbers with 2 decimals
      if (!isNaN(parseFloat(event.value))) return this.$utils.formatNumber(event.value, '0,0.[00]')
      return event.value
    },

    async markAsRead (event) {
      let error
      [error] = await to(this.$api.patchLastEvent(event, { read: true }))
      if (error) return

      this.$emit('update')
      this.$store.dispatch('getLastGatewayEventsCounters', { loader: false, defaultErrorMessage: false })
      this.$store.dispatch('getRncGatewaysLastEventsCounters', { loader: false, defaultErrorMessage: false })
      this.$store.dispatch('getLastLnsEventsCounters', { loader: false, defaultErrorMessage: false })
    }
  }
}
</script>

<style lang="scss">
  // Scope does not work as it's a component style
  .gateway-last-events .table-responsive {
    // 223px to display 6 lines and a space for horizontal scrollbar
    height: 223px;
  }
</style>
